import { render, staticRenderFns } from "./RoutePoint.vue?vue&type=template&id=84b9963e&scoped=true&"
import script from "./RoutePoint.vue?vue&type=script&lang=js&"
export * from "./RoutePoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b9963e",
  null
  
)

export default component.exports